import Page, { getStaticProps as compGetStaticProps } from 'components/pages/PrivacyPolicy';

export const getStaticProps = compGetStaticProps;
export default Page;
